import request from "@/utils/request";

const loadAccounts = () => {
  return request.get("/api/settings/accounts");
};

const unlinkSocialAccount = (type) => request
  .delete("/api/social_accounts", {
    params: { type },
    token: true
  });

const addLogin = (email, password) => request
  .post("/api/blinkist_account", {
    body: { email, password },
    token: true
  });

const changePassword = (oldPassword, newPassword) => request
  .put("/api/password", {
    body: {
      old_password: oldPassword, /* eslint-disable-line camelcase */
      password1: newPassword,
      password2: newPassword
    },
    token: true
  });

const changeEmail = (email, password) => request
  .put("/api/blinkist_account", {
    body: {
      email,
      password
    },
    token: true
  });

const cancelSubscription = (cancellationReason) => request
  .delete("/api/subscription", {
    body: {
      reason: cancellationReason
    },
    token: true
  });

const deleteAccount = password => request
  .delete("/api/blinkist_account", {
    body: { password },
    token: true
  });

const loadEmailPreferences = () => {
  return request.get("/api/settings/email_optins");
};

const addToList = (email) => request
  .patch(`/api/settings/email_optins/${email}`, {
    token: true
  });

const removeFromList = (email) => request
  .delete(`/api/settings/email_optins/${email}`, {
    token: true
  });

const updateEmailSubscriptionStatus = (status) => request
  .patch(`/api/settings/email_subscription_status/${status}`, {
    token: true
  });

export default {
  loadAccounts,
  unlinkSocialAccount,
  addLogin,
  changePassword,
  changeEmail,
  cancelSubscription,
  deleteAccount,
  loadEmailPreferences,
  addToList,
  removeFromList,
  updateEmailSubscriptionStatus
};
